import React, { useEffect, useState } from 'react';
import { Card, CardBody, Row, Col, Button, Alert } from 'reactstrap';
import { urlCalcularPrimaApAbierto, urlPdfApAbierto, urlProcesoApAbierto } from '../../constants/urls';
import { Textbox, Textarea } from "react-inputs-validation";
import { FetchDescargarCotizacionAbierto } from '../../redux/actions/aCotizacion';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorMsgConstants } from '../../constants';
import NumberFormat from 'react-number-format';
import { fetchGuardarEmisionRetroactiva } from '../../redux/actions/aRamoAccidentesPersonales';
import moment from 'moment';




const Valores = ({
  verBoton,
  carritoActual,
  productos,
  editaAsistencias,
  setEditaAsistencias,
  totales,
  idCarrito,
  descripcionSeguro,
  idProducto,
  categoriaObjeto,
  categoria,
  numeroPersonas,
  muerteAccidental,
  valorFracturaHuesos,
  numeroDias,
  setTotales,
  paso,
  valuesCoberturas,
  setValuesCoberturas,
  valuesAsistencia,
  setValuesAsistencia,
  tieneErrores,
  history,
  setTieneErrores,
  coberturas2,
  setCoberturas2,
  asistencias,
  setAsistencias,
  asistenciasSeleccionadas,
  setAsistenciasSeleccionadas,
  loading,
  codProducto,
  setLoading,
  urlPdf,
  calcular,
  guardarPersonas,
  errorGlobal,
  onClickResumen,
  duplicada,
  titulo,
  urlSiguiente,
  personaDuplicadaMasivo,
  setPersonaDuplicadaMasivo,
  idDuplicadaMasivo,
  tituloPrimaNeta = 'Prima Neta',
  tituloPrimaTotal = 'Prima Total',
  requiereEmision = false,
  vigenciaRetroactiva = null,
  errorVigenciaRetroactiva = false,
  omitir
}) => {

  const [tieneError, setTieneError] = useState(false)

  const [correo, setCorreo] = useState('')
  const [validate, setValidate] = useState(false)
  const [hasCorreoError, setHasCorreoError] = useState(false)

  const [errorMensaje, setErrorMensaje] = useState('')
  const [visibleAlert, setVisibleAlert] = useState(false)
  const [okEnvio, setOkEnvio] = useState(false)
  const [tieneVacios, setTieneVacios] = useState(false)
  const [tieneVaciosCategoria, setTieneVaciosCategoria] = useState('')

  const dispatch = useDispatch()

  const descargarCotizacion = (datos) => dispatch(FetchDescargarCotizacionAbierto(datos))
  const datosCotizacion = useSelector((state) => state.generarCotizacionPdfAP)
  const datosUsuario = useSelector((state) => state.datosUsuarios.dataUsuario)

  const [valorPrimaNeta, setValorPrimaNeta] = useState(0)
  const [valorPrimaTotal, setValorPrimaTotal] = useState(0)



  const guardarEmisionRetroactiva = datos => {
    dispatch(fetchGuardarEmisionRetroactiva(datos));
  };







  const onDismiss = () => {
    setVisibleAlert(!visibleAlert)
  }

  const buscarVacios = () => {

    var aux = false
    if (!omitir) {
      productos.forEach(producto => {
        if (!producto.datosPersonas || producto.datosPersonas.length < 1) {
          aux = true
          setTieneVaciosCategoria(producto.datosAp.actividad.label)
        }
      });
    }
    return aux
  }


  const onEnviar = async () => {

    let datosJson = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      accion: "enviar",
      correo: correo,
      idCarrito: idCarrito,
      url: urlPdf,
    }
    setLoading(true)
    await descargarCotizacion(datosJson)
    setLoading(false)
    setOkEnvio(true)

    setTimeout(() => {
      setOkEnvio(false)
      setCorreo('')
    }, 5000);
    console.log('datosCotizacion', datosCotizacion)

    //let datosPago=this.props.datosCotizacion.datosDescarga;
    if (!datosCotizacion.generarCotizacionHasError) {
      //let newTab = window.open();
      //window.location.href = datosPago.urlPdf;
      //window.open(datosPago.urlPdf, "_blank")
    }


  }

  /**
   * Guarda la información de la cotización seleccionada
   * @param {Object} values valores a guardar
   */
  const guardarInformacion = async (values) => {
    var url = `${urlProcesoApAbierto}`;
    setLoading(true)
    const body = {
      "empresa": "AIGMETROPOLITANA",
      "plataforma": "WEB",
      "ambiente": "Desarrollo",
      "descripcionSeguro": descripcionSeguro,
      "pasoCarrito": "guardarDataCobertura",
      "idCarrito": idCarrito,
      "direccion": "TEST",
      "codigoProductoActual": idProducto ? idProducto : "",


      "datosProductos": {
        "actividad": categoriaObjeto,
        "transaccion": true,
        "codCobertura": categoriaObjeto.value,
        "codProducto": codProducto,
        "tituloPlanCobertura": titulo,
        "numeroPersonas": numeroPersonas,
        "valorMuerteAccidental": muerteAccidental,
        "valorFracturaHuesos": valorFracturaHuesos,
        "numeroDias": numeroDias,
        "coberturas": totales.coberturas,
        "asistencias": totales.asistencias,
        "primaNetaPorPersona": totales.primaNetaPorPersona,
        "primaNetaTotal": totales.primaNetaTotal,
        "totalAsistencia": totales.totalAsistencia,
        "primaNetaPorPersonaConAsistencia": totales.primaNetaPorPersonaConAsistencia,
        "primaNetaTotalConAsistencias": totales.primaNetaTotalConAsistencias,
        "totalEnAsistenciaPorPersona": totales.totalEnAsistenciaPorPersona

      }
    }
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
      const json = await response.json()
      console.log('verUrl', json)
      if (json.transaccion) {
        history.push({
          pathname: urlSiguiente,
          search: `?id=${json.idCarrito}`, //agregar parametros de la url,
        });
      }
      console.log('verUrl', json)
      setLoading(false)
    } catch (error) {
      console.log('verUrl', error)
      setLoading(false)
    }
  }

  /**
   * Calcular el valor de la prima de acuerdo a parámetros ingresados por el usuario 
   */
  const calcularPrima = async () => {
    var url = `${urlCalcularPrimaApAbierto}`;
    setLoading(true)
    var coberturasAux = []
    for (const key in valuesCoberturas) {
      const element = valuesCoberturas[key];


      const cobertura = coberturas2.find(cobertura => cobertura.codigoCobertura == key)
      console.log('cobertura', cobertura)
      const nuevoObjeto = {
        "codigoCobertura": cobertura.codigoCobertura,
        "nombreCobertura": cobertura.cobertura,
        "codigoCoberturaPadre": cobertura.codigoCoberturaPadre ? cobertura.codigoCoberturaPadre : null,
        "valorAsegurado": element,
      }
      coberturasAux.push(nuevoObjeto)
    }

    console.log('carritoActual', carritoActual.facturacion.value)
    console.log('carritoActual', totales)

   


    var body = {
      "codCobertura": categoria,
      "empresa": "AIGMETROPOLITANA",
      "numeroPersonas": numeroPersonas,
      "valorMuerteAccidental": muerteAccidental,
      "valorFracturaHuesos": valorFracturaHuesos,
      "numeroDias": numeroDias,
      "brokerId": datosUsuario.cliCodigoCore,
      "sucursal": carritoActual.sucursal.value,
      "coberturas": coberturasAux,
      "asistencias": asistenciasSeleccionadas,
      "carDescripcionSeguro": carritoActual.carDescripcionSeguro,
      "periodoFacuracion": carritoActual.facturacion.value
    }
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
      const json = await response.json()
      console.log('verCoberturas', body.coberturas)

      if(body.coberturas){
        const coEncontrada = body.coberturas.find(co=> co.codigoCobertura == '15' )
        console.log('verCoberturas', coEncontrada)

        if(coEncontrada){
          if(coEncontrada.valorAsegurado <1){

            setTieneError(true)
            setErrorMensaje('El valor del deducible Gastos Médicos por Accidente debe ser igual o mayor a 10')
            setTotales({})
            setLoading(false)

            return false

          }
        }
      }
      if (json.transaccion) {
        setTotales(json)
        setTieneError(false)

        if(parseInt(carritoActual.facturacion.value) == 6){

          console.log('json', json)

      

          setValorPrimaNeta(json.primaNetaPorPersonaConAsistenciaMensual)
          setValorPrimaTotal(json.primaNetaTotalConAsistenciasMensual)
    
        }else{
       
          setValorPrimaNeta(json.primaNetaPorPersonaConAsistencia)
          setValorPrimaTotal(json.primaNetaTotalConAsistencias)
        }
      } else {
        setTieneError(true)
        setErrorMensaje(json.errorDescripcion)
        setTotales({})
      }
      setEditaAsistencias(false)
      setLoading(false)

    } catch (error) {
      setLoading(false)
      setEditaAsistencias(false)
      setTotales({})
    }
  }

  const onClickEnviar = () => {

    console.log(hasCorreoError)
    if (
      correo &&
      correo !== "" &&
      correo !== null &&
      hasCorreoError === false
    ) {
      console.log('llegue')
      onEnviar(correo);
    }
  }





  return (
    <Card className=' div-flotante'>
      <CardBody>
        <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>

        {(paso == 'resumen' || paso == 'cargaVidas') &&
          <div>
            <Row>
              <Col lg={6} md={6} sm={6} xs={6} >
                <h4>{tituloPrimaNeta}</h4>
              </Col>
              <Col lg={6} md={6} sm={6} xs={6}>

                <NumberFormat
                  value={parseFloat(totales.prima_neta_anual_full_cobertura ? totales.prima_neta_anual_full_cobertura : '0.00')}
                  className="foo"
                  displayType={'text'}
                  thousandSeparator={'.'}
                  decimalScale={2}
                  fixedDecimalScale={2}
                  decimalSeparator={','}
                  prefix={'$'}
                  renderText={(value, props) => <div {...props}>
                    <h5>{value}</h5>
                  </div>}
                />

              </Col>

              {/*  <Col lg={6} md={6} sm={6} xs={6}>
              <h5>{totales.primaNetaTotal ? "$" + totales.primaNetaTotal : '$0.00'}</h5>
            </Col> */}
            </Row>
            <Row>
              <div id="container-imp">
                <div className="accordion-imp">
                  <input type="checkbox" id="tm" />
                  <label htmlFor="tm" className="accordionitem">
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h4 title={"Presiona click para ver/ocultar el detalle impuestos"} >
                          Impuestos{" "}
                          <i
                            className="fa fa-info-circle"
                            aria-hidden="true"
                          />
                        </h4>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.totalImpuestos)}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div {...props}>
                            <h5>{value}</h5>
                          </div>}
                        />


                      </Col>
                    </Row>
                  </label>
                  <div className="hiddentext ocultar">


                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>IVA</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.iva_Full_Cobertura)}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div
                            {...props}>
                            <h5>{value}</h5>
                          </div>
                          }
                        />

                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>Super bancos 3.5 %</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.super_bancos_Full_Cobertura)}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div
                            {...props}>
                            <h5>{value}</h5>
                          </div>
                          }
                        />

                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>Seguro Campesino</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.seguro_campesino_Full_Cobertura)}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div
                            {...props}>
                            <h5>{value}</h5>
                          </div>
                          }
                        />

                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>Derechos de Emisión</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.derecho_emision_Full_Cobertura)}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div
                            {...props}>
                            <h5>{value}</h5>
                          </div>
                          }
                        />

                      </Col>
                    </Row>





                  </div>


                  <hr />

                </div>
              </div>
            </Row>
            <Row>
              <Col lg={6} md={6} sm={6} xs={6}>
                <h5 style={{ fontWeight: "bold" }}>{tituloPrimaTotal}</h5>
              </Col>
              <Col lg={6} md={6} sm={6} xs={6}>
                <NumberFormat
                  value={parseFloat(totales.totalcarrito)}
                  className="foo"
                  displayType={'text'}
                  thousandSeparator={'.'}
                  decimalSeparator={','}
                  decimalScale={2}
                  fixedDecimalScale={2}
                  prefix={'$'}
                  renderText={(value, props) => <div
                    {...props}>
                    <h5 style={{ fontWeight: "bold" }}>
                      {value}
                    </h5>
                  </div>
                  }
                />


              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                {(urlPdf && paso == 'resumen') && (
                  <a
                    className='btn btn-detail-white'
                    href={urlPdf}
                    target='_blank'
                    rel='noopener noreferrer'>
                    <i
                      className='fa fa-cloud-download'
                      aria-hidden='true'
                    />{" "}
                    DESCARGAR COTIZACIÓN
                  </a>
                )}
              </Col>

            </Row>
            {(urlPdf && paso == 'resumen') && (
              <Row>
                <Col lg={8} md={12} sm={12} xs={12}>
                  <Textbox
                    tabIndex="1"
                    type="input"
                    value={correo}
                    name="correo"
                    id="correo"
                    classNameInput={"form-control"}
                    onChange={(correo, e) => {
                      setCorreo(correo)
                    }}
                    placeholder="Por favor ingrese el correo" // Optional.[String].Default: "".
                    validate={validate}
                    validationCallback={(res) => {

                      setHasCorreoError(res)
                      setValidate(!res)



                    }} // Optional.[Func].Default: none. Return the validation result.
                    onBlur={(e) => {
                      // this.setState({ blur: true });
                      //console.log("BLUUUR");
                    }}
                    validationOption={{
                      name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                      check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                      required: true,
                      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      regMsg: "Por favor ingrese un correo válido",
                      msgOnError: "Por favor ingrese un correo válido", // Optional.[Bool].Default: true. To determin if it is a required field.
                    }}
                  />
                </Col>
                <Col lg={4} md={12} sm={12} xs={12}>
                  <Button
                    className="btn btn-detail-white"
                    onClick={() => {
                      onClickEnviar()
                    }

                    }
                  >
                    <i className="fa fa-paper-plane-o" aria-hidden="true" /> ENVIAR
                  </Button>
                </Col>
                {okEnvio && (
                  <Alert
                    color="success"
                    isOpen={okEnvio}
                    toggle={() => onDismiss()}
                  >
                    <center>
                      <p>
                        Se ha enviado correctamente la cotización al correo
                        electrónico ingresado.
                      </p>
                    </center>
                  </Alert>
                )}
              </Row>
            )}
          </div>


        }

        {paso == 'cotizacion' &&
          <div>
            <Row>


              <Col lg={6} md={6} sm={6} xs={6} >

                <h4>{tituloPrimaNeta}</h4>
              </Col>
              <Col lg={6} md={6} sm={6} xs={6}>
                <NumberFormat
                  value={parseFloat(valorPrimaNeta ? valorPrimaNeta : '0.00')}
                  className="foo"
                  displayType={'text'}
                  thousandSeparator={'.'}
                  decimalScale={2}
                  fixedDecimalScale={2}
                  decimalSeparator={','}
                  prefix={'$'}
                  renderText={(value, props) => <div {...props}>

                    <h5>{value}</h5>

                  </div>}
                />
              </Col>




              {/*  <Col lg={6} md={6} sm={6} xs={6}>
              <h5>{totales.primaNetaTotal ? "$" + totales.primaNetaTotal : '$0.00'}</h5>
            </Col> */}
            </Row>

            <Row>
              <Col lg={6} md={6} sm={6} xs={6}>

                <h5 style={{ fontWeight: "bold" }}>{tituloPrimaTotal}</h5>
              </Col>
              <Col lg={6} md={6} sm={6} xs={6}>

                <NumberFormat
                  value={parseFloat(valorPrimaTotal ? valorPrimaTotal : '0.00')}
                  className="foo"
                  displayType={'text'}
                  thousandSeparator={'.'}
                  decimalSeparator={','}
                  decimalScale={2}
                  fixedDecimalScale={2}
                  prefix={'$'}
                  renderText={(value, props) => <div {...props}>
                    <h5 style={{ fontWeight: "bold" }}>
                      {value}
                    </h5>
                  </div>}
                />


              </Col>
            </Row>
          </div>


        }


        {paso == 'cotizacion' && verBoton &&
          <Button
            className={
              (!totales.primaNetaPorPersona || editaAsistencias)
                ? "btn btn-primary btn-purple fe-pulse"
                : "btn btn-primary"
            }
            onClick={() => {

              var tieneErroresAux = false


              for (const key in tieneErrores) {
                const element = tieneErrores[key];

                if (element == true) {
                  tieneErroresAux = true
                }
              }

              if (!tieneErroresAux) {

                if (totales.primaNetaPorPersona && !editaAsistencias) {
                  guardarInformacion(valuesCoberturas)
                } else {
                  calcularPrima()
                }

              }

            }}
            style={{ display: "block", margin: "auto", width: 200, height: 40 }}
          >
            <i
              className="fa fa-chevron-circle-right"
              aria-hidden="true"
            />{" "}
            {(totales.primaNetaPorPersona && !editaAsistencias) ? "CONTINUAR" : "CALCULAR"}
          </Button>
        }

        {paso == 'resumen' &&
          <div>
            <Button
              className={
                "btn btn-primary"
              }
              onClick={() => {

                if (requiereEmision && errorVigenciaRetroactiva) {
                  return false
                }

                if (requiereEmision) {
                   guardarEmisionRetroactiva({
                    "empresa": "AIGMETROPOLITANA",
                    "plataforma": "WEB",
                    "idCarrito": idCarrito,
                    "fechaEmisionRetroactivaFutura": moment(new Date(vigenciaRetroactiva)).format('DD/MM/YYYY'),
                    "emisionRetroactivaFutura": requiereEmision
                  })
                }

                onClickResumen()

              }}
              style={{ display: "block", margin: "auto", width: 200, height: 40 }}
            >
              <i
                className="fa fa-chevron-circle-right"
                aria-hidden="true"
              />{" "}
              {"INICIAR EMISIÓN"}
            </Button>
            {duplicada
              ?
              <div>
                <br></br>
                <Alert color="danger">
                  <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                </Alert>
              </div>

              :
              null
            }
          </div>


        }

        {paso == 'cargaVidas' &&
          <div>
            <Button
              // disabled={!calcular}
              className={
                calcular
                  ? "btn btn-primary btn-purple fe-pulse"
                  : "btn btn-primary"
              }
              onClick={() => {

                if (calcular) {
                  guardarPersonas(false)
                } else {

                  const vacios = buscarVacios()
                  if (vacios) {
                    setTieneVacios(true)

                  } else {
                    if(omitir){
                      guardarPersonas(true)
                    }else{
                      setTieneVacios(false)
                      history.push({
                        pathname: "/datos-facturacion",
                        search: `?id=${idCarrito}`, //agregar parametros de la url,
                      });
                    }
              
                  }





                }

              }}
              style={{ display: "block", margin: "auto", width: 200, height: 40 }}
            >
              <i
                className="fa fa-chevron-circle-right"
                aria-hidden="true"
              />{" "}
              {!calcular ? "CONTINUAR" : "CALCULAR"}
            </Button>
            <br></br>

            {(errorGlobal != '') &&
              <Alert
                color="danger"
                isOpen={(errorGlobal != '')}
                toggle={() => onDismiss()}
              >
                <center>
                  <p>
                    {errorGlobal}
                  </p>
                </center>
              </Alert>
            }
          </div>
        }

        {tieneError &&
          <div>
            <br></br>
            <Alert color="warning">


              {
                errorMensaje
              }


            </Alert>
          </div>



        }

        {paso == 'cargaVidas' &&
          <Alert
            color="danger"
            isOpen={personaDuplicadaMasivo && paso == 'cargaVidas'}
          >
            <center>
              <p>
                La persona con Nro. de identificación {idDuplicadaMasivo} se encuentra duplicada, por favor revise los datos

              </p>
            </center>
          </Alert>
        }

        {paso == 'cargaVidas' && tieneVacios &&
          <Alert
            color="danger"
            isOpen={paso == 'cargaVidas' && tieneVacios}
          >
            <center>
              <p>
                {`La categoría "${tieneVaciosCategoria}" no tiene personas asignadas, por favor realice la carga de las vidas`}

              </p>
            </center>
          </Alert>
        }



      </CardBody>
    </Card>
  );
};

export default Valores;
